// extracted by mini-css-extract-plugin
module.exports = {"container":"GroupOrderMaxAttendeeLimitNote_container__pSPlC"};